var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetroFlowBranch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.252,
    height: 10.097,
    viewBox: "0 0 13.252 10.097",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.362 10.097a1.893 1.893 0 10-1.709-2.695c-1.249-.065-1.674-1-2.284-2.631a10.3 10.3 0 00-.973-2.09h3.246a1.893 1.893 0 100-1.578H3.609a1.894 1.894 0 10-.006 1.59c1.249.065 1.674 1 2.284 2.631.6 1.6 1.35 3.582 3.751 3.66a1.891 1.891 0 001.724 1.113zm1.092-8.2A1.092 1.092 0 1111.362.802a1.092 1.092 0 011.089 1.092zm-11.65 0a1.092 1.092 0 111.092 1.092A1.092 1.092 0 01.804 1.897zm9.458 6.307a1.092 1.092 0 111.1 1.092 1.092 1.092 0 01-1.1-1.092z",
    fill: "#9d9c9c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetroFlowBranch);
export default __webpack_public_path__ + "static/media/metro-flow-branch.5dcd0818.svg";
export { ForwardRef as ReactComponent };